"use client";

import { BookOpen, Calendar, ChefHat, LayoutDashboard } from "lucide-react";
import { useTranslations } from "next-intl";

import { SettingsRow } from "@/components/settings/SettingsRow";
import { SettingsSection } from "@/components/settings/SettingsSection";
import type { PageTutorialId } from "@/lib/storage";

function openPageTutorial(page: PageTutorialId) {
  window.dispatchEvent(new CustomEvent("open-page-tutorial", { detail: page }));
}

function openListsTutorial() {
  window.dispatchEvent(new CustomEvent("open-tutorial"));
}

export function TutorialSection() {
  const t = useTranslations("settings");

  return (
    <SettingsSection className="p-0 overflow-hidden">
      <SettingsRow onClick={() => openPageTutorial("dashboard")}>
        <LayoutDashboard className="size-5 shrink-0 text-muted-foreground" aria-hidden />
        <span className="font-medium">{t("tutorial_dashboard")}</span>
      </SettingsRow>
      <div className="border-t border-border mx-4" />
      <SettingsRow onClick={openListsTutorial}>
        <BookOpen className="size-5 shrink-0 text-muted-foreground" aria-hidden />
        <span className="font-medium">{t("tutorialLists")}</span>
      </SettingsRow>
      <div className="border-t border-border mx-4" />
      <SettingsRow onClick={() => openPageTutorial("recipes")}>
        <ChefHat className="size-5 shrink-0 text-muted-foreground" aria-hidden />
        <span className="font-medium">{t("tutorial_recipes")}</span>
      </SettingsRow>
      <div className="border-t border-border mx-4" />
      <SettingsRow onClick={() => openPageTutorial("calendar")}>
        <Calendar className="size-5 shrink-0 text-muted-foreground" aria-hidden />
        <span className="font-medium">{t("tutorial_calendar")}</span>
      </SettingsRow>
    </SettingsSection>
  );
}
